/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum AvailableActions {
    ACCEPT = 'ACCEPT',
    REJECT = 'REJECT'
}
